"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JiraApis = void 0;
const Operarations = require("./generated-client/apis/index");
const JsmOperarations = require("./genarated-jsm-client/apis/index");
class JiraApis {
    getIssueApi() {
        return new Operarations.IssuesApi(this.getBackendConfig());
    }
    getAnnouncementBannerApi() {
        return new Operarations.AnnouncementBannerApi(this.getBackendConfig());
    }
    getApplicationRolesApi() {
        return new Operarations.ApplicationRolesApi(this.getBackendConfig());
    }
    getIssueFieldsApi() {
        return new Operarations.IssueFieldsApi(this.getBackendConfig());
    }
    getWorkflowTransitionPropertiesApi() {
        return new Operarations.WorkflowTransitionPropertiesApi(this.getBackendConfig());
    }
    getWorflowTransitionRulesApi() {
        return new Operarations.WorkflowTransitionRulesApi(this.getBackendConfig());
    }
    getWorkflowStatusesApi() {
        return new Operarations.WorkflowStatusesApi(this.getBackendConfig());
    }
    getWorkflowSchemesApi() {
        return new Operarations.WorkflowSchemesApi(this.getBackendConfig());
    }
    getWorkflowStatusCategoriesApi() {
        return new Operarations.WorkflowStatusCategoriesApi(this.getBackendConfig());
    }
    getWorkflowSchemeProjectAssociationsApi() {
        return new Operarations.WorkflowSchemeProjectAssociationsApi(this.getBackendConfig());
    }
    getWorkflowSchemeDraftsApi() {
        return new Operarations.WorkflowSchemeDraftsApi(this.getBackendConfig());
    }
    getWorkflowsApi() {
        return new Operarations.WorkflowsApi(this.getBackendConfig());
    }
    getWebhooksApi() {
        return new Operarations.WebhooksApi(this.getBackendConfig());
    }
    getUsersApi() {
        return new Operarations.UsersApi(this.getBackendConfig());
    }
    getUserPropertiesApi() {
        return new Operarations.UserPropertiesApi(this.getBackendConfig());
    }
    getUserSearchApi() {
        return new Operarations.UserSearchApi(this.getBackendConfig());
    }
    getUIModificationsAppsApi() {
        return new Operarations.UIModificationsAppsApi(this.getBackendConfig());
    }
    getTimeTrackingApi() {
        return new Operarations.TimeTrackingApi(this.getBackendConfig());
    }
    getTasksApi() {
        return new Operarations.TasksApi(this.getBackendConfig());
    }
    getStatusApi() {
        return new Operarations.StatusApi(this.getBackendConfig());
    }
    getServiceRegistryApi() {
        return new Operarations.ServiceRegistryApi(this.getBackendConfig());
    }
    getServerInfoApi() {
        return new Operarations.ServerInfoApi(this.getBackendConfig());
    }
    getScreenTabsApi() {
        return new Operarations.ScreenTabsApi(this.getBackendConfig());
    }
    getScreenTabFieldsApi() {
        return new Operarations.ScreenTabFieldsApi(this.getBackendConfig());
    }
    getScreenSchemesApi() {
        return new Operarations.ScreenSchemesApi(this.getBackendConfig());
    }
    getScreensApi() {
        return new Operarations.ScreensApi(this.getBackendConfig());
    }
    getProjectVersionsApi() {
        return new Operarations.ProjectVersionsApi(this.getBackendConfig());
    }
    getProjectTypesApi() {
        return new Operarations.ProjectTypesApi(this.getBackendConfig());
    }
    getProjectRoleActorsApi() {
        return new Operarations.ProjectRoleActorsApi(this.getBackendConfig());
    }
    getProjectRolesApi() {
        return new Operarations.ProjectRolesApi(this.getBackendConfig());
    }
    getProjectPropertiesApi() {
        return new Operarations.ProjectPropertiesApi(this.getBackendConfig());
    }
    getProjectPermissionSchemesApi() {
        return new Operarations.ProjectPermissionSchemesApi(this.getBackendConfig());
    }
    getProjectKeyAndNameValidationApi() {
        return new Operarations.ProjectKeyAndNameValidationApi(this.getBackendConfig());
    }
    getProjectCategoriesApi() {
        return new Operarations.ProjectCategoriesApi(this.getBackendConfig());
    }
    getProjectsApi() {
        return new Operarations.ProjectsApi(this.getBackendConfig());
    }
    getProjectFeaturesApi() {
        return new Operarations.ProjectFeaturesApi(this.getBackendConfig());
    }
    getProjectComponentsApi() {
        return new Operarations.ProjectComponentsApi(this.getBackendConfig());
    }
    getProjectAvatarsApi() {
        return new Operarations.ProjectAvatarsApi(this.getBackendConfig());
    }
    getProjectEmailApi() {
        return new Operarations.ProjectEmailApi(this.getBackendConfig());
    }
    getProjectClassificationLevelsApi() {
        return new Operarations.ProjectClassificationLevelsApi(this.getBackendConfig());
    }
    getPermissionSchemesApi() {
        return new Operarations.PermissionSchemesApi(this.getBackendConfig());
    }
    getPermissionsApi() {
        return new Operarations.PermissionsApi(this.getBackendConfig());
    }
    getMyselfApi() {
        return new Operarations.MyselfApi(this.getBackendConfig());
    }
    getLicenseMetricsApi() {
        return new Operarations.LicenseMetricsApi(this.getBackendConfig());
    }
    getLabelsApi() {
        return new Operarations.LabelsApi(this.getBackendConfig());
    }
    getJQLFunctionsAppsApi() {
        return new Operarations.JQLFunctionsAppsApi(this.getBackendConfig());
    }
    getJQLApi() {
        return new Operarations.JQLApi(this.getBackendConfig());
    }
    getJiraSettingsApi() {
        return new Operarations.JiraSettingsApi(this.getBackendConfig());
    }
    getJiraExpressionsApi() {
        return new Operarations.JiraExpressionsApi(this.getBackendConfig());
    }
    getIssueWorklogsApi() {
        return new Operarations.IssueWorklogsApi(this.getBackendConfig());
    }
    getIssueWorklogPropertiesApi() {
        return new Operarations.IssueWorklogPropertiesApi(this.getBackendConfig());
    }
    getIssueWatchersApi() {
        return new Operarations.IssueWatchersApi(this.getBackendConfig());
    }
    getIssueVotesApi() {
        return new Operarations.IssueVotesApi(this.getBackendConfig());
    }
    getIssueTypeScreenSchemesApi() {
        return new Operarations.IssueTypeScreenSchemesApi(this.getBackendConfig());
    }
    getIssueTypeSchemesApi() {
        return new Operarations.IssueTypeSchemesApi(this.getBackendConfig());
    }
    getIssueTypesApi() {
        return new Operarations.IssueTypesApi(this.getBackendConfig());
    }
    getIssueTypePropertiesApi() {
        return new Operarations.IssueTypePropertiesApi(this.getBackendConfig());
    }
    getIssueSecuritySchemesApi() {
        return new Operarations.IssueSecuritySchemesApi(this.getBackendConfig());
    }
    getIssueSecurityLevelApi() {
        return new Operarations.IssueSecurityLevelApi(this.getBackendConfig());
    }
    getIssueSearchApi() {
        return new Operarations.IssueSearchApi(this.getBackendConfig());
    }
    getIssueResolutionsApi() {
        return new Operarations.IssueResolutionsApi(this.getBackendConfig());
    }
    getIssueRemoteLinksApi() {
        return new Operarations.IssueRemoteLinksApi(this.getBackendConfig());
    }
    getIssuePropertiesApi() {
        return new Operarations.IssuePropertiesApi(this.getBackendConfig());
    }
    getIssueNavigatorSettingsApi() {
        return new Operarations.IssueNavigatorSettingsApi(this.getBackendConfig());
    }
    getIssueNotificationSchemesApi() {
        return new Operarations.IssueNotificationSchemesApi(this.getBackendConfig());
    }
    getIssueLinkTypesApi() {
        return new Operarations.IssueLinkTypesApi(this.getBackendConfig());
    }
    getIssueLinksApi() {
        return new Operarations.IssueLinksApi(this.getBackendConfig());
    }
    getIssueFieldConfigurationsApi() {
        return new Operarations.IssueFieldConfigurationsApi(this.getBackendConfig());
    }
    getIssueCustomFieldOptionsApi() {
        return new Operarations.IssueCustomFieldOptionsApi(this.getBackendConfig());
    }
    getIssueCustomFieldContextsApi() {
        return new Operarations.IssueCustomFieldContextsApi(this.getBackendConfig());
    }
    getIssueCustomFieldConfigurationsAppsApi() {
        return new Operarations.IssueCustomFieldConfigurationAppsApi(this.getBackendConfig());
    }
    getIssueCustomFieldValuesAppsApi() {
        return new Operarations.IssueCustomFieldValuesAppsApi(this.getBackendConfig());
    }
    getIssueCustomFieldOptionsAppsApi() {
        return new Operarations.IssueCustomFieldOptionsAppsApi(this.getBackendConfig());
    }
    getIssueCommentPropertiesApi() {
        return new Operarations.IssueCommentPropertiesApi(this.getBackendConfig());
    }
    getIssueCommentsApi() {
        return new Operarations.IssueCommentsApi(this.getBackendConfig());
    }
    getIssueAttachmentsApi() {
        return new Operarations.IssueAttachmentsApi(this.getBackendConfig());
    }
    getGroupsApi() {
        return new Operarations.GroupsApi(this.getBackendConfig());
    }
    getGroupAndUserPickerApi() {
        return new Operarations.GroupAndUserPickerApi(this.getBackendConfig());
    }
    getFilterSharingApi() {
        return new Operarations.FilterSharingApi(this.getBackendConfig());
    }
    getFiltersApi() {
        return new Operarations.FiltersApi(this.getBackendConfig());
    }
    getDynamicModulesApi() {
        return new Operarations.DynamicModulesApi(this.getBackendConfig());
    }
    getDashboardsApi() {
        return new Operarations.DashboardsApi(this.getBackendConfig());
    }
    getClassificationLevelsApi() {
        return new Operarations.ClassificationLevelsApi(this.getBackendConfig());
    }
    getAvatarsApi() {
        return new Operarations.AvatarsApi(this.getBackendConfig());
    }
    getAuditRecordsApi() {
        return new Operarations.AuditRecordsApi(this.getBackendConfig());
    }
    getAppPropertiesApi() {
        return new Operarations.AppPropertiesApi(this.getBackendConfig());
    }
    getAppMigrationApi() {
        return new Operarations.AppMigrationApi(this.getBackendConfig());
    }
    getAssetsApi() {
        return new JsmOperarations.AssetsApi(this.getBackendConfig());
    }
    getCustomerApi() {
        return new JsmOperarations.CustomerApi(this.getBackendConfig());
    }
    getInfoApi() {
        return new JsmOperarations.InfoApi(this.getBackendConfig());
    }
    getKnowledgebaseApi() {
        return new JsmOperarations.KnowledgebaseApi(this.getBackendConfig());
    }
    getOrganizationApi() {
        return new JsmOperarations.OrganizationApi(this.getBackendConfig());
    }
    getRequestApi() {
        return new JsmOperarations.RequestApi(this.getBackendConfig());
    }
    getRequesttypeApi() {
        return new JsmOperarations.RequesttypeApi(this.getBackendConfig());
    }
    getServicedeskApi() {
        return new JsmOperarations.ServicedeskApi(this.getBackendConfig());
    }
}
exports.JiraApis = JiraApis;
//# sourceMappingURL=JiraApis.js.map